<div class="splash-screen" @splashAnimation>
  <div class="splash-background" [style.background-image]="'url(assets/common/dealer-image.png)'"></div>
  <div class="logo-overlay">
    <img src="assets/common/Incadea-logo.png" alt="incadea" [class]="['incadea-logo', 'animated-logo', logoVisible ? 'logo-visible' : '', logoMoved ? 'logo-moved' : '']" />
    <div class="incadea-wordmark" [class.show-wordmark]="showWordmark">
      <img src="assets/common/Wordmark.png" alt="incadea wordmark" class="wordmark-image" />
    </div>
  </div>
  <div class="logo-description">
     <img src="assets/common/dealer-logo.png" alt="incadea logo" class="incadea-logo" />
     <div class="welcome-text">Global leader in Automotive Software Industry</div>
  </div>
  <div class="copyright-bottom">
     © 2026 incadea All Rights Reserved
  </div>
</div>
